<template>
	<q-select
		filter
		autofocus-filter
		v-model="value"
		:chips="options.length <= 14 ? true : false"
		:display-value="
			options.length >= 15
				? filters.length > 0
					? `${filterCount} itens selecionados`
					: null
				: null
		"
		:options="options"
		multiple
		:float-label="$t(label)"
		clearable
		@input="onInput"
		:error="error ? error : null"
		:disable="disable"
	/>
</template>

<script>
export default {
	props: ['options', 'filters', 'label', 'input', 'error', 'disable'],

	computed: {
		value: {
			get() {
				return this.filters
			},
			set(val) {
				this.$emit('on_value', val)
			},
		},
		filterCount() {
			return this.filters.filter((value) => {
				return this.options.find((item) => item.value == value)
			}).length
		},
	},
	methods: {
		onInput() {
			if (typeof this.input === 'function') {
				this.input()
			}
		},
	},
}
</script>

<style></style>
